export default "/assets/website/images/store-1.jpeg?a1f8bd2ba693b16fb55d24494aa06fc6";